// Data source configuration
export const DATA_CONFIG = {
  // Primary data source (S3 or external URL)
  PRIMARY_DATA_URL: process.env.APP_DATA_URL || 'https://thekuddyfoundation.s3.us-east-1.amazonaws.com/data.json',
  
  // Fallback data source (local public folder)
  FALLBACK_DATA_URL: '/data.json',
  
  // Request timeout in milliseconds
  REQUEST_TIMEOUT: 5000,
  
  // Enable console logging for debugging
  DEBUG_LOGGING: process.env.NODE_ENV === 'development'
};

// Helper to log debug information
export const debugLog = (message: string, data?: any) => {
  if (DATA_CONFIG.DEBUG_LOGGING) {
    console.log(`[DataConfig] ${message}`, data || '');
  }
};